<template>
  <v-alert
    title="Error"
    variant="outlined"
    type="warning"
    prominent
    border="top"
  >
    {{ errorMessage }}
  </v-alert>
</template>

<script>
import DataService from "../services/DataService";

export default {
  name: "ErrorPage",
  props: {
    errorcode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      errorMessage: "",
    };
  },
  mounted() {
    this.errorMessage = DataService.getErrorMessage( this.errorcode );
  }
};
</script>

<style scoped>


</style>
